import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgStarOutline = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M26.16 10.638a1.79 1.79 0 0 0-1.56-1.232l-6.452-.52-2.492-6.026a1.789 1.789 0 0 0-3.31 0l-2.49 6.024-6.456.522a1.8 1.8 0 0 0-1.025 3.157l4.922 4.247-1.5 6.35a1.791 1.791 0 0 0 2.68 1.95L14 21.71l5.527 3.4a1.794 1.794 0 0 0 2.676-1.95l-1.505-6.351 4.922-4.247a1.8 1.8 0 0 0 .54-1.924m-1.677.598-5.327 4.594a.88.88 0 0 0-.28.865l1.628 6.869a.04.04 0 0 1-.019.052c-.02.015-.025.012-.041 0l-5.985-3.68a.88.88 0 0 0-.917 0l-5.985 3.682c-.016.01-.02.013-.042 0a.04.04 0 0 1-.018-.052l1.627-6.869a.88.88 0 0 0-.28-.865l-5.326-4.594c-.013-.01-.025-.02-.015-.055.011-.034.02-.03.037-.031l6.99-.565a.88.88 0 0 0 .736-.54l2.693-6.52c.008-.018.012-.027.038-.027s.03.009.038.027l2.7 6.52a.88.88 0 0 0 .738.538l6.991.564c.017 0 .026 0 .036.032s0 .044-.017.055"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStarOutline);
export default ForwardRef;
